import * as dayjs from 'dayjs';

export const formatDate = (
  date: string,
  format: string = 'MMMM DD, YYYY',
): string => {
  return dayjs(date).format(format);
};
